import React, { useContext, useEffect, useState, useRef, useMemo } from 'react'
import ProductAccessories from './ProductAccessories'
import { SiteContext } from '../../Global/SiteContext'
import { useDigifiSearchCore } from '../../DigifiSearch/Hooks/Core/useDigifiSearchCore'

const ProductGroupCarousel = ({ type }) => {
   const { productInformation } = useContext(SiteContext)
   const productGroups = useMemo(() => 
      productInformation?.productGroups ?? [], 
      [productInformation?.productGroups]
   )
   const { getProductsByItemNos } = useDigifiSearchCore()
   const [associatedProducts, setAssociatedProducts] = useState([])
   const isMountedRef = useRef(true)

   const productIdsToFetch = useMemo(() => {
      const filteredGroups = productGroups.filter(group => group.type == type)
      const productIds = filteredGroups.flatMap(group => group.productIds || [])
      return productIds.filter(id => id !== productInformation?.id)
   }, [productGroups, type, productInformation?.id])

   const groupName = useMemo(() => {
      const filteredGroups = productGroups.filter(group => group.type == type)
      return filteredGroups[0]?.name
   }, [productGroups, type])

   const generateTitleKey = () => {
      switch(type) {
         case "0":
            return "more products from"
        case "1":
            return "other colors"
         case "2":
            return "other sizes"
         default:
            return "recommended accessories"
      }
   }

   console.log(productIdsToFetch)

   useEffect(() => {
      if (!Array.isArray(productIdsToFetch) || productIdsToFetch.length === 0) {
         setAssociatedProducts([])
         return
      }

      isMountedRef.current = true

      ;(async () => {
         if (!isMountedRef.current) return

         const products = await getProductsByItemNos({
            itemNos: productIdsToFetch,
            pageSize: 150,
         })

         console.log(products)

         // Sort products to match the order of productIdsToFetch
         const sortedProducts = productIdsToFetch
            .map(id => products?.find(product => product.id === id))
            .filter(Boolean)
            .sort((a, b) => {
               // First sort by inStock (1 = in stock, 0 = not in stock)
               if (a.inStock !== b.inStock) {
                  return b.inStock - a.inStock // In stock products first
               }
               // If stock status is the same, maintain the original order from productIdsToFetch
               return 0
            })

         console.log(sortedProducts)

         if (isMountedRef.current) {
            setAssociatedProducts(sortedProducts || [])
         }
      })()

      return () => {
         isMountedRef.current = false // Marks component as unmounted to prevent state updates from ongoing API calls
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [productIdsToFetch])

   return <ProductAccessories accessories={associatedProducts} titleKey={generateTitleKey(type)} title={groupName} />
}

export default ProductGroupCarousel
